import React from 'react';
import ProductsList from '../components/sections/ProductsList';

const ProductsPage = () => {
  return <ProductsList />;
};

export default ProductsPage;
